var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "134", height: "76", viewBox: "0 0 134 76", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "DeliverableThumb"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M4 0h126a4 4 0 0 1 4 4v67.856a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z", fill: "#D8D8D8" }),
      React.createElement("path", { d: "M82.271 18H51.062A1.06 1.06 0 0 0 50 19.061V56.94A1.06 1.06 0 0 0 51.062 58h31.21a1.06 1.06 0 0 0 1.061-1.061V19.06c0-.585-.474-1.061-1.062-1.061zM60 22.167h17.5v2.5H60v-2.5zM55 20.5c1.384 0 2.5 1.119 2.5 2.5 0 1.384-1.119 2.5-2.5 2.5a2.501 2.501 0 0 1-2.5-2.5 2.496 2.496 0 0 1 2.5-2.5zm25.833 34.167h-27.5v-27.5h27.5v27.5z", fill: "#FFF", fillRule: "nonzero" })
    )
  );
});